import * as Yup from 'yup';


export const formValidationSchema = Yup.object().shape({
  pushMessagesRadius: Yup.number().nullable(),
});
